import { render } from "./SearchTerms.vue?vue&type=template&id=a9cee71a&scoped=true"
import script from "./SearchTerms.vue?vue&type=script&lang=js"
export * from "./SearchTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9cee71a"]])

export default __exports__